import { createContext } from "react"
import type URI from "../domain/URI.js"

/**
 * @description
 *	A context that provides the current active route taken directly from the
 *	browser in the form of a parsed URI model.
 */
const RouterContext = createContext<URI | undefined>(undefined)

export default RouterContext
